import { ApiService } from "./api.service";
import type {
  TCreateProjectViewRequest,
  TCreateWorkspaceViewRequest,
  TProjectView,
  TUpdateProjectViewRequest,
  TUpdateWorkspaceViewRequest,
  TWorkspaceView,
} from "@/types/view";

export class ViewService extends ApiService {
  async listProjectViews(slug: string, projectId: string): Promise<TProjectView[]> {
    return this.get(`/api/workspaces/${slug}/projects/${projectId}/views/`);
  }

  async createProjectView(
    slug: string,
    projectId: string,
    data: TCreateProjectViewRequest,
  ): Promise<TProjectView> {
    return this.post(`/api/workspaces/${slug}/projects/${projectId}/views/`, data);
  }

  async getProjectView(slug: string, projectId: string, viewId: string): Promise<TProjectView> {
    return this.get(`/api/workspaces/${slug}/projects/${projectId}/views/${viewId}/`);
  }

  async updateProjectView(
    slug: string,
    projectId: string,
    viewId: string,
    data: TUpdateProjectViewRequest,
  ): Promise<TProjectView> {
    return this.patch(`/api/workspaces/${slug}/projects/${projectId}/views/${viewId}/`, data);
  }

  async deleteProjectView(slug: string, projectId: string, viewId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/projects/${projectId}/views/${viewId}/`);
  }

  async listWorkspaceViews(slug: string): Promise<TWorkspaceView[]> {
    return this.get(`/api/workspaces/${slug}/views/`);
  }

  async createWorkspaceView(
    slug: string,
    data: TCreateWorkspaceViewRequest,
  ): Promise<TWorkspaceView> {
    return this.post(`/api/workspaces/${slug}/views/`, data);
  }

  async getWorkspaceView(slug: string, viewId: string): Promise<TWorkspaceView> {
    return this.get(`/api/workspaces/${slug}/views/${viewId}/`);
  }

  async updateWorkspaceView(
    slug: string,
    viewId: string,
    data: TUpdateWorkspaceViewRequest,
  ): Promise<TWorkspaceView> {
    return this.patch(`/api/workspaces/${slug}/views/${viewId}/`, data);
  }

  async deleteWorkspaceView(slug: string, viewId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/views/${viewId}/`);
  }
}
